/**
 * @generated SignedSource<<b1baf47b73b6fe2febde31e881968d22>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type realtimeUpdaterOld_nativeIssueTable_groups$data = {
  readonly __id: string;
  readonly edges: ReadonlyArray<{
    readonly __typename: "JiraSpreadsheetGroupEdge";
  } | null | undefined> | null | undefined;
  readonly groupByField: string | null | undefined;
  readonly jql: string | null | undefined;
  readonly " $fragmentType": "realtimeUpdaterOld_nativeIssueTable_groups";
};
export type realtimeUpdaterOld_nativeIssueTable_groups$key = {
  readonly " $data"?: realtimeUpdaterOld_nativeIssueTable_groups$data;
  readonly " $fragmentSpreads": FragmentRefs<"realtimeUpdaterOld_nativeIssueTable_groups">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "realtimeUpdaterOld_nativeIssueTable_groups",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "jql"
    },
    {
      "kind": "ScalarField",
      "name": "groupByField"
    },
    {
      "concreteType": "JiraSpreadsheetGroupEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraSpreadsheetGroupConnection"
};

(node as any).hash = "c0c4073f08cdf2c448a3724cdb78b071";

export default node;
